import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TaskListResponse } from '@TheGreenHouseCompany/vegiwise-sdk-typescript/dist/generated/@dto/responses/location/task-list.response';
import { SharedModule } from '../../ui-components/shared.module';
import { CheckIconComponent } from '../../../@icons/check-icon.component';
import { LabelPipe } from '../../pipes/LabelPipe';
import { currentAppLang, formatVwDayRange } from '../../pipes/vw-date.pipe';
import { TASK_EMOJIS } from '../../constants/garden-task.constants';
import { isLunarDayFor } from '../../utils/garden-todo.util';

/**
 * La feuille d'une tâche (maquette 03) : le geste, la pastille de sa culture et
 * celle de sa catégorie, sa période, la lune seulement quand le jour s'y
 * prête, le comment du geste, puis « C'est fait » et « Ignorer cette fois ».
 *
 * Ouverte tant qu'elle a une tâche. La dernière tâche reste dessinée pendant
 * que la feuille descend : elle ne se vide pas sous le doigt.
 */
@Component({
  selector: 'vw-garden-task-sheet',
  standalone: true,
  imports: [SharedModule, TranslatePipe, LabelPipe, CheckIconComponent],
  templateUrl: './garden-task-sheet.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class GardenTaskSheetComponent {
  /** L'influence lunaire du jour (« root »), ou nulle quand on ne la connaît pas. */
  @Input() todayInfluence: string | null = null;
  @Output() done = new EventEmitter<void>();
  @Output() skip = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  private readonly translate = inject(TranslateService);

  readonly emojis = TASK_EMOJIS;
  isOpen = false;
  shown: TaskListResponse | null = null;

  @Input() set task(task: TaskListResponse | null) {
    this.isOpen = !!task;
    if (task) this.shown = task;
  }

  /** « Du 1er au 30 avril » : les bornes de la période, dans la langue de l'app. */
  get period(): { from: string; to: string } {
    return formatVwDayRange(this.shown?.startDate, this.shown?.endDate, currentAppLang(this.translate));
  }

  get isLunarDay(): boolean {
    return isLunarDayFor(this.shown?.gardenTask?.lunarInfluence, this.todayInfluence);
  }
}
